export default __webpack_public_path__ + "static/media/diamond-clarity-3.c6ddc555.png";